import React, { useState } from 'react';
import { Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import TabsLanguage from '../../../../../components/widgets/TabsLanguage';
import CusInput from '../../../../../components/material-ui/CusInput';
import CusSwitch from '../../../../../components/material-ui/CusSwitch';
import useToast from '../../../../../hooks/useToast';
import CusQuill from '../../../../../components/material-ui/CusQuill';

export default function MessageFirstDeposit({
  texDeptLang,
  setTexDeptLang,
  enabledMesDep,
  setEnabledMesDep,
  defaultLang,
  setDefaultLang
}) {
  const { t } = useTranslation();
  const { infoToast } = useToast();
  const [lang, setLang] = useState(defaultLang);

  return (
    <Stack component={'section'} gap={3}>
      <Typography variant="h6">{t('Send a message after the first deposit')}</Typography>
      <Stack gap={1}>
        <CusSwitch
          label={'Send messages'}
          checked={enabledMesDep}
          onChange={() => setEnabledMesDep((prev) => !prev)}
        />
        <Stack gap={1}>
          <TabsLanguage lang={lang} setLang={setLang} />
          <CusSwitch
            label={'Default language'}
            key={lang + '_reg_switch'}
            checked={lang == defaultLang}
            tooltipText={
              'Turn On a different default language and it will be turned off automatically here!'
            }
            onChange={() => {
              setDefaultLang(lang);

              const textTurnOf =
                'Turn On a different default language and it will be turned off automatically here!';

              if (lang == defaultLang) infoToast(textTurnOf);
            }}
          />
          {/* <CusInput
            key={'mes-text-' + lang}
            label={'Message text'}
            tooltipText={'An empty message will not be sent.'}
            rows={4}
            value={texDeptLang[lang]}
            onChange={(e) => {
              const value = e.target.value;
              setTexDeptLang((prev) => ({ ...prev, [lang]: value }));
            }}
          /> */}

          <CusQuill
            key={'mes-text-' + lang}
            isTgMode
            value={texDeptLang[lang]}
            onChange={(value) => setTexDeptLang((prev) => ({ ...prev, [lang]: value }))}
          />
        </Stack>
      </Stack>
    </Stack>
  );
}
